import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import KetoContainer from './keto-container';
import styles from './keto-mobile.module.css';
import KetoPaper from './keto-paper';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';

export default function KetoMobile() {
  return (
    <section className={styles.mobile}>
      <KetoContainer>
        <div className={styles.mobile_inner}>
          <AnimationOnScroll
            offset={400}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInLeft"
            className={styles.mobile_start}
          >
            <KetoTypography
              className={styles.mobile_title}
              variant={KetoTypographyVariant.HEADLINE_1}
              tag="h1"
            >
              Grocery List
            </KetoTypography>
            <KetoPaper>
              <KetoTypography
                className={styles.mobile_text}
                variant={KetoTypographyVariant.BODY_2}
                tag="p"
              >
                Use your phone as your personal grocery shopping assistant that
                collects the groceries you need right from the meals you want to
                cook.
              </KetoTypography>
            </KetoPaper>
          </AnimationOnScroll>
          <AnimationOnScroll
            offset={400}
            duration={1.2}
            animateOnce
            animateIn="animate__swing"
            className={styles.mobile_center}
          >
            <Image
              alt="spoon"
              width={454}
              height={776}
              src="/keto/banner/spoon.png"
            />
          </AnimationOnScroll>
          <AnimationOnScroll
            offset={400}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInRight"
            className={styles.mobile_end}
          >
            <Image
              alt="keto kitchen app screen"
              width={426}
              height={723}
              src="/keto/banner/phone.png"
            />
          </AnimationOnScroll>

          <img
            alt="fat icon"
            className={styles.fat}
            src="/keto/icons/fat.svg"
          />
          <img
            className={styles.carbs}
            src="/keto/icons/carbs.svg"
            alt="crabs icon"
          />
        </div>
      </KetoContainer>
    </section>
  );
}
